var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgIconSearch = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.64456 0.833496C4.77861 0.833496 0.833984 4.69101 0.833984 9.44948C0.833984 14.208 4.77861 18.0655 9.64456 18.0655C11.7257 18.0655 13.6383 17.3598 15.1459 16.1799L18.0096 18.9731L18.0858 19.0372C18.3517 19.2296 18.7286 19.2078 18.9692 18.9719C19.2338 18.7124 19.2333 18.2923 18.968 18.0335L16.1379 15.2731C17.5768 13.7396 18.4551 11.6948 18.4551 9.44948C18.4551 4.69101 14.5105 0.833496 9.64456 0.833496ZM9.64456 2.16059C13.761 2.16059 17.0981 5.42394 17.0981 9.44948C17.0981 13.475 13.761 16.7384 9.64456 16.7384C5.5281 16.7384 2.19105 13.475 2.19105 9.44948C2.19105 5.42394 5.5281 2.16059 9.64456 2.16059Z",
    fill: "#C6CCD2"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgIconSearch, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/icon-search.87393dc4.svg";
export { ForwardRef as ReactComponent };